import { useEffect, useState } from "react";
import { useCusAuth } from "@utils/store/auth/useCusAuth";
import { useUser } from "@utils/store/user/useUser";
import { buildXContextHeader } from "@utils/api/headers";
import { getCustomerDeliveryList, CustomerDelivery } from "@components/delivery/API/handleDeliveryAPI";

/**
 * 讀取目前送達地址下、使用者已儲存的安裝位置（customer_delivery）。
 * 拉不到時靜默回空陣列，不擋使用者新增。
 */
export function useCustomerDeliveries(): CustomerDelivery[] {
  const { cusJwtToken } = useCusAuth();
  const { chooseIdentity } = useUser();
  const customerAddressId = chooseIdentity?.choose_address?.customer_address_id;
  const xContext = buildXContextHeader(chooseIdentity) || "";
  const [list, setList] = useState<CustomerDelivery[]>([]);

  useEffect(() => {
    if (!customerAddressId || !cusJwtToken) {
      setList([]);
      return;
    }
    let cancelled = false;
    (async () => {
      const res = await getCustomerDeliveryList({ customerAddressId, jwtToken: cusJwtToken, xContext });
      if (cancelled) return;
      if (res.state === "success") setList(res.data);
      else {
        console.warn("getCustomerDeliveryList failed", res.error);
        setList([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [customerAddressId, cusJwtToken, xContext]);

  return list;
}
